export default __webpack_public_path__ + "static/media/cclogout.9aa16aa1.svg";